import React from 'react';
import { SYSTEM_STEPS } from '../data/mock';
import { Reveal, AnimatedDivider } from './effects';

const TheSystem = () => {
  return (
    <section className="relative py-28 lg:py-44 bg-[#EFEBE3] overflow-hidden">
      <div className="container-x">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-20">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-7">
              <AnimatedDivider width="3rem" />
              <Reveal delay={100} y={8} duration={700}>
                <span className="text-[10.5px] tracking-[0.34em] uppercase text-[#9A7F4F] font-medium">
                  Tarhun Sistemi
                </span>
              </Reveal>
            </div>
            <Reveal delay={200}>
              <h2
                className="font-display text-[40px] lg:text-[60px] text-[#1A1A1A] leading-[1.04] tracking-[-0.02em]"
                style={{ fontWeight: 500 }}
              >
                Üç adım,{' '}
                <span className="italic font-light text-[#9A7F4F]">kusursuz</span>{' '}
                kurumsal yemek operasyonu.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:pt-20">
            <Reveal delay={400}>
              <p className="text-[15px] lg:text-[16px] text-[#1A1A1A]/72 leading-[1.7] max-w-md">
                Söz vermiyoruz, protokol imzalıyoruz. Her adım yazılı süreçle yönetilir; her vardiyada aynı disiplin, her tabakta aynı standart.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Steps grid — staggered reveal */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
          {SYSTEM_STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 180} y={36}>
              <article
                className="group relative aspect-[3/4] overflow-hidden rounded-sm shadow-[0_24px_60px_-30px_rgba(114,39,45,0.35)]"
              >
                <img
                  src={s.image.startsWith('http') ? `${s.image}?auto=format&fit=crop&q=85&w=1200` : s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.07]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#72272D]/95 via-[#72272D]/45 to-[#72272D]/10 transition-opacity duration-700 group-hover:from-[#72272D]/85" />

                <div className="absolute top-7 left-7 lg:top-9 lg:left-9">
                  <div className="font-display numeric text-[64px] lg:text-[84px] text-[#C9A875] leading-none transition-transform duration-700 group-hover:translate-y-[-4px]">
                    {s.step}
                  </div>
                  <div className="h-px w-12 bg-[#C9A875]/60 mt-3 transition-all duration-700 group-hover:w-20" />
                </div>

                <div className="absolute bottom-0 inset-x-0 p-7 lg:p-9 transition-transform duration-700 group-hover:translate-y-[-4px]">
                  <h3 className="font-display text-[32px] lg:text-[40px] text-[#F5F0E5] leading-[1.05] tracking-[-0.01em] font-medium">
                    {s.title}
                  </h3>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TheSystem;
